import { render, staticRenderFns } from "./GuangzhouTelecom1.vue?vue&type=template&id=aeee13ea&scoped=true"
import script from "./GuangzhouTelecom1.vue?vue&type=script&lang=js"
export * from "./GuangzhouTelecom1.vue?vue&type=script&lang=js"
import style0 from "./GuangzhouTelecom1.vue?vue&type=style&index=0&id=aeee13ea&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aeee13ea",
  null
  
)

export default component.exports